import React, { useEffect } from "react";
import "./style/range.css";
import { useRangeFilter } from "../../../context/rangeFilterContext";
import { useZone } from "../../../context/ZoneContext";
import ar from "../../../lang/ar";
import en from "../../../lang/en";
function Range({ lang }) {
  const { 
    updateRangeFilters,
    areaHandles,
    priceHandles,
    updateHandles,
  } = useRangeFilter();
  const { units, loading } = useZone();
  const allAreas = units
    .map((u) => Number(u.built_up_area || 0))
    .filter((v) => v > 0);
  const allPrices = units
    .map((u) => Number(u.actual_price || 0))
    .filter((v) => v > 0);
  const minArea = Math.floor(Math.min(...allAreas));
  const maxArea = Math.ceil(Math.max(...allAreas));
  const minPrice = Math.floor(Math.min(...allPrices));
  const maxPrice = Math.ceil(Math.max(...allPrices));
const translations = lang === "ar" ? ar : en;
  // ────────────────────────────────────────────────────────────────
  // إعادة تهيئة القيم الأولية عند تغيير الوحدات
  // ────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (!minArea || !maxArea || !minPrice || !maxPrice) return;

    const newArea = { min: minArea, max: maxArea };
    const newPrice = { min: minPrice, max: maxPrice };

    updateRangeFilters({
      area: newArea,
      price: newPrice,
    });
    updateHandles("area", { left: minArea, right: maxArea });
    updateHandles("price", { left: minPrice, right: maxPrice });
  }, [minArea, maxArea, minPrice, maxPrice, updateRangeFilters, updateHandles]);

  const updateHandle = (value, handleSide, type) => {
    const minVal = type === "area" ? minArea : minPrice;
    const maxVal = type === "area" ? maxArea : maxPrice;

    const current = type === "area" ? areaHandles : priceHandles;

    let newLeft = current.left;
    let newRight = current.right;

    if (handleSide === "left") newLeft = Number(value);
    if (handleSide === "right") newRight = Number(value);

    // منع التداخل
    if (newLeft < minVal) newLeft = minVal;
    if (newRight > maxVal) newRight = maxVal;
    if (newLeft > newRight) {
      if (handleSide === "left") newLeft = newRight;
      else newRight = newLeft;
    }

    const newRange = {
      min: Math.min(newLeft, newRight),
      max: Math.max(newLeft, newRight),
    };

    // 1. حدث الفلتر الفعلي
    updateRangeFilters({ [type]: newRange });

    // 2. حدث المقابض في الـ context (عشان كل الـ Range يشوفوا نفس القيم)
    updateHandles(type, { left: newLeft, right: newRight });
  };

  if (!allAreas.length || !allPrices.length) {
    return (
      <div className="range d-flex flex-column gap-3 col-12 text-center text-muted">
       {lang === "ar" ? " لا توجد بيانات مساحة أو أسعار صالحة حاليًا" : "No valid area or price data at the moment"}
      </div>
    );
  }

  if (loading || !units?.length) {
    return (
      <div className="range d-flex flex-column gap-3 col-12 text-center text-muted">
        {lang === "ar" ? " يتم التحميل..." : "Loading..."}
      </div>
    );
  }

  return (
    <div className="range d-flex flex-column gap-3 col-12">
      {/* مساحة */}
      <div className="flex flex-column">
        <p className="p-0 filter-title">{lang === "ar" ? "مساحة  م²" : "Area (m2)"}</p>
        <div className="range-container">
          <button>{Math.round(areaHandles.left)}</button>

          <div className="range-slider">
            <input
              type="range"
              className="thumb thumb-left"
              min={minArea}
              max={maxArea}
              step="1"
              value={areaHandles.left}
              onChange={(e) => updateHandle(e.target.value, "left", "area")}
            />
            <input
              type="range"
              className="thumb thumb-right"
              min={minArea}
              max={maxArea}
              step="1"
              value={areaHandles.right}
              onChange={(e) => updateHandle(e.target.value, "right", "area")}
            />
            <div
              className="track"
              style={{
                left: `${((areaHandles.left - minArea) / (maxArea - minArea)) * 100}%`,
                width: `${((areaHandles.right - areaHandles.left) / (maxArea - minArea)) * 100}%`,
              }}
            />
          </div>

          <button>{Math.round(areaHandles.right)}</button>
        </div>
      </div>

      {/* سعر */}
      <div className="flex flex-column">
        <p className="p-0 filter-title">{lang === "ar" ? "السعر (مليون)" : "Price (M)"}</p>
        <div className="range-container">
          <button>{priceHandles.left.toLocaleString()}</button>

          <div className="range-slider">
            <input
              type="range"
              className="thumb thumb-left"
              min={minPrice}
              max={maxPrice}
              step="1"
              value={priceHandles.left}
              onChange={(e) => updateHandle(e.target.value, "left", "price")}
            />
            <input
              type="range"
              className="thumb thumb-right"
              min={minPrice}
              max={maxPrice}
              step="1"
              value={priceHandles.right}
              onChange={(e) => updateHandle(e.target.value, "right", "price")}
            />
            <div
              className="track"
              style={{
                left: `${((priceHandles.left - minPrice) / (maxPrice - minPrice)) * 100}%`,
                width: `${((priceHandles.right - priceHandles.left) / (maxPrice - minPrice)) * 100}%`,
              }}
            />
          </div>

          <button>{priceHandles.right.toLocaleString()}</button>
        </div>
      </div>
    </div>
  );
}

export default Range;
